import { formatDate as formatUiDate, useTranslation } from '@hbs-us/ui';

import { useSession } from '../../../auth/useSession.js';

/**
 * The line at the top of Home, shared by every layout.
 *
 * Home renders a different set of cards for an owner and for a crew member, but it is still one
 * screen and it greets everybody the same way. Keeping the greeting in one component is what stops
 * the two layouts drifting into two different-looking products.
 */
export function HomeGreeting() {
  const { t, i18n } = useTranslation();
  const { session } = useSession();
  const locale = i18n.language || 'en';
  const hour = new Date().getHours();
  const dayPeriod = hour < 12 ? 'morning' : hour < 17 ? 'afternoon' : 'evening';
  const firstName = session?.user.name.trim().split(/\s+/)[0] ?? '';
  const today = formatUiDate(new Date(), locale, {
    weekday: 'long',
    month: 'short',
    day: 'numeric',
  });

  return (
    <header className="mb-4">
      <h1 className="font-display font-semibold text-3xl text-foreground tracking-tight">
        {t('home:title', { period: t(`home:greeting.${dayPeriod}`), name: firstName })}
      </h1>
      <p className="mt-1 text-muted-foreground text-sm">
        {t('home:subtitle', { date: today, tenantName: session?.tenant.name ?? '' })}
      </p>
    </header>
  );
}
